/**
 * Subir la biblia o la escaleta que el autor YA tiene (Rais, 21-sep: «también debería dejar subir
 * una biblia si hay un documento previo, y una escaleta»). Se copia a la carpeta del proyecto con
 * el nombre que el motor busca —`biblia.docx`, `escaleta.md`…—, así la reconoce sin preguntar. El
 * original no se toca.
 */
import { useState } from "react";
import { subir } from "../api";
import type { Fichero } from "../api";

export default function SubirDocumento({ carpeta, tipo, alSubido }: {
  carpeta: string; tipo: "biblia" | "escaleta"; alSubido: (f: Fichero, aviso: string) => void;
}) {
  const [ocupado, setOcupado] = useState(false);
  const [fallo, setFallo] = useState<string | null>(null);

  async function recibir(f: File | undefined) {
    if (!f) return;
    const ext = (f.name.match(/\.(docx|md)$/i)?.[1] ?? "").toLowerCase();
    if (!ext) { setFallo("Tiene que ser un .docx o un .md."); return; }
    setOcupado(true); setFallo(null);
    try {
      const r = await subir(carpeta, f, `${tipo}.${ext}`);
      const aviso = r.name.toLowerCase() === `${tipo}.${ext}`
        ? `Tu ${tipo} está en la carpeta del proyecto como «${r.name}». El original, «${f.name}», no se toca.`
        : `Ya había un fichero con ese nombre, así que se ha guardado como «${r.name}». Para que el Studio la reconozca como tu ${tipo}, renómbralo a «${tipo}.${ext}».`;
      alSubido(r, aviso);
    } catch (e) { setFallo((e as Error).message); } finally { setOcupado(false); }
  }

  return (
    <>
      <label className="btn fantasma" style={{ cursor: ocupado ? "wait" : "pointer" }}>
        {ocupado ? "Subiendo…" : "Subir la mía"}
        <input type="file" hidden accept=".docx,.md" disabled={ocupado}
               onChange={(e) => { recibir(e.target.files?.[0]); e.target.value = ""; }} />
      </label>
      {fallo && <p className="vacio" style={{ color: "var(--acc)" }}>{fallo}</p>}
    </>
  );
}
